/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReservePaymentResult = {
  paymentUrl: string;
  status: ReservePaymentResult.status;
  merchantTransactionNo: string;
};
export namespace ReservePaymentResult {
  export enum status {
    RESERVED = 'RESERVED',
    CONFIRMED = 'CONFIRMED',
    FAILED = 'FAILED',
    REFUNDED = 'REFUNDED',
  }
}

